import { Center } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { IHoverOverlayProps } from './interfaces';

const HoverOverlay: React.FC<IHoverOverlayProps> = ({ index, onClick }) => (
  <Center
    bgColor="#546959"
    top={0}
    w="100%"
    h="100%"
    pos="absolute"
    zIndex={1}
    opacity={0}
    className="overlay"
    transition="all .3s ease-in-out"
    onClick={() => onClick(index)}
  >
    <FontAwesomeIcon icon={faPlus} width={70} height={70} color="white" />
  </Center>
);

export default HoverOverlay;
